import { useTranslation, Trans } from "react-i18next";

//Styling
import '../../../css/Legal.css'

export default function PrivacyPolicy({ isNavOpen }) {
  const { t } = useTranslation();


  return (
    <div className={`${isNavOpen ? "body-squeezed" : "body"}`}>
      <div className="legal-page">

        {/* TITLE */}
        <h2>{t("privacy.title")}</h2>
        <p className="legal-updated">{t("privacy.lastUpdated")}</p>



        {/* INTRO */}
        <p>{t("privacy.intro1")}</p>
        <p>{t("privacy.intro2")}</p>
        <p>{t("privacy.intro3")}</p>

        {/* 1. OVERVIEW */}
        <h3>{t("privacy.overview.title")}</h3>
        <p>{t("privacy.overview.text1")}</p>
        <p>{t("privacy.overview.text2")}</p>
        <p>{t("privacy.overview.text3")}</p>
        <p>{t("privacy.overview.text4")}</p>

        {/* 2. INFORMATION WE COLLECT */}
        <h3>{t("privacy.info.title")}</h3>
        <p>{t("privacy.info.text")}</p>

        {/* 2.1 DIRECT INFO */}
        <h4>{t("privacy.info.direct.title")}</h4>
        <ul>
          {t("privacy.info.direct.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        {/* 2.2 AUTOMATIC INFO */}
        <h4>{t("privacy.info.auto.title")}</h4>
        <p>{t("privacy.info.auto.text")}</p>
        <ul>
          {t("privacy.info.auto.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <p><strong>{t("privacy.info.auto.notCollecting")}</strong></p>
        <ul>
          {t("privacy.info.auto.notCollecting.items", {
            returnObjects: true,
          }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        {/* 2.3 STRIPE */}
        <h4>{t("privacy.stripe.title")}</h4>
        <p>{t("privacy.stripe.text1")}</p>
        <ul>
          {t("privacy.stripe.notStored", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <p>{t("privacy.stripe.text2")}</p>
        <p>{t("privacy.stripe.weReceive")}</p>

        <ul>
          {t("privacy.stripe.weReceive.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        {/* 3. USE OF INFORMATION */}
        <h3>{t("privacy.use.title")}</h3>
        <ul>
          {t("privacy.use.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <p><strong>We do NOT use information for:</strong></p>
        <ul>
          {t("privacy.use.not", { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        {/* 4. COOKIES */}
        <h3>{t("privacy.cookies.title")}</h3>
        <p>{t("privacy.cookies.text")}</p>

        {/* 4.1 REFRESH COOKIE */}
        <h4>{t("privacy.cookies.refresh.title")}</h4>
        <p>{t("privacy.cookies.refresh.text")}</p>

        <ul>
          {t("privacy.cookies.refresh.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <p>{t("privacy.cookies.noTracking")}</p>

        {/* 4.2 NO ANALYTICS */}
        <h4>{t("privacy.cookies.none.title")}</h4>
        <ul>
          {t("privacy.cookies.none.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        {/* 4.3 COOKIE BANNER */}
        <h4>{t("privacy.cookies.banner.title")}</h4>
        <p>{t("privacy.cookies.banner.text1")}</p>
        <p>{t("privacy.cookies.banner.text2")}</p>

        {/* 5. EMAILS */}
        <h3>{t("privacy.emails.title")}</h3>
        <ul>
          {t("privacy.emails.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>
        <p>{t("privacy.emails.noMarketing")}</p>

        {/* 6. DISCLOSURE */}
        <h3>{t("privacy.disclosure.title")}</h3>

        <h4>Service Providers</h4>
        <ul>
          {t("privacy.disclosure.serviceProviders", {
            returnObjects: true,
          }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <h4>School Administrators</h4>
        <ul>
          {t("privacy.disclosure.admins", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        <h4>Legal Requirements</h4>
        <ul>
          {t("privacy.disclosure.legal", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        {/* 7. RETENTION */}
        <h3>{t("privacy.retention.title")}</h3>
        <ul>
          {t("privacy.retention.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>
        <p>{t("privacy.retention.deletion")}</p>

        {/* 8. SECURITY */}
        <h3>{t("privacy.security.title")}</h3>
        <ul>
          {t("privacy.security.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>
        <p>{t("privacy.security.note")}</p>

        {/* 9. RIGHTS */}
        <h3>{t("privacy.rights.title")}</h3>
        <ul>
          {t("privacy.rights.items", { returnObjects: true }).map(
            (item, index) => (
              <li key={index}>{item}</li>
            )
          )}
        </ul>

        {/* 10. INTERNATIONAL */}
        <h3>{t("privacy.intl.title")}</h3>
        <p>{t("privacy.intl.text")}</p>

        {/* 11. CHANGES */}
        <h3>{t("privacy.changes.title")}</h3>
        <p>{t("privacy.changes.text")}</p>

        {/* 12. CONTACT */}
        <h3>{t("privacy.contact.title")}</h3>
        <p>{t("privacy.contact.text")}</p>
        {/* 17. Contact */}
        <h3>{t("terms.contact.title")}</h3>
        <p>{t("terms.contact.text")}</p>
        <br />
        <p>
          <strong>DNZIFY</strong><br />
          Suite 250 - #1633<br />
          997 Seymour St.<br />
          Vancouver, BC, Canada<br />
          V6B 3M1<br />
          contact@dnzify.com
        </p>

      </div>
    </div>
  );
}
